import React from 'react';
import { useSelector } from 'react-redux';
import QRCode from 'react-qr-code';

import './PrintTicket.css';

import PrintHeader from '../PrintHeader';
import { formattedDate } from '../../../utils/dateUtils';
import { travelRoutes } from '../../../config/constants/rutas';

export const PrintTicket = React.forwardRef(
  (
    {
      id,
      fecha,
      puestos,
      origen,
      destino,
      customer,
      precio,
      observaciones,
      usuario,
      estado,
      created_at,
      public_url,
      stamp,
      cufe,
      billing_name
    },
    ref
  ) => {
    const { companies } = useSelector(state => state.companies);
    const currentCompany = companies.length > 0 ? companies[0] : null;
    const travelRoute = travelRoutes.find(
      item =>
        item.origen.toLowerCase() === origen.toLowerCase() &&
        item.destino.toLowerCase() === destino.toLowerCase()
    );
    return (
      <div ref={ref} className="ticket-container">
        <PrintHeader />
        <span className="ticket-anulado">{estado === 'ANULADO' && estado}</span>
        <hr />
        <table>
          <tbody>
            <tr className="tr-border" key="tiquete">
              <td>Tiquete No:</td>
              <td align="right">
                <strong>{id}</strong>
              </td>
            </tr>
            {billing_name && (
              <tr className="tr-border" key="factura">
                <td>Factura electronica:</td>
                <td align="right">
                  <strong>{billing_name}</strong>
                </td>
              </tr>
            )}
          </tbody>
        </table>
        Fecha de expedición:
        <p className="clear-space">
          <strong>{formattedDate(created_at)}</strong>
        </p>
        Fecha y hora de salida:
        <p className="clear-space">
          <strong>{fecha}</strong>
        </p>
        Cédula cliente:
        <p className="clear-space">
          <strong>{customer.id}</strong>
        </p>
        Nombre cliente:
        <p className="clear-space">
          <strong>{customer.nombre}</strong>
        </p>
        <table>
          <tbody>
            <tr className="tr-border" key="puestos">
              <td>Puestos:</td>
              <td align="right">
                <strong>{puestos}</strong>
              </td>
            </tr>
            <tr className="tr-border" key="origen">
              <td>Origen del pasajero:</td>
              <td align="right">
                <strong>{origen}</strong>
              </td>
            </tr>
            <tr className="tr-border" key="destino">
              <td>Destino del pasajero:</td>
              <td align="right">
                <strong>{destino}</strong>
              </td>
            </tr>
            <tr className="tr-border" key="ruta">
              <td>Ruta:</td>
              <td align="right">
                <strong>{travelRoute.ruta || ''}</strong>
              </td>
            </tr>
            <tr className="tr-border" key="valor">
              <td>Valor:</td>
              <td align="right">
                <strong>{`$ ${Number(precio).toLocaleString('es-ES')}`}</strong>
              </td>
            </tr>
          </tbody>
        </table>
        <div className="observaciones">
          <strong>Observaciones:</strong>
          <p>{observaciones}</p>
        </div>
        <div className="observaciones text-footer">
          <p className="clear-space">{`Nombre empresa aseguradora:`}</p>
          <p>{currentCompany.insurance}</p>
          <p className="clear-space">{`Vendedor: ${usuario}`}</p>
          <p className="clear-space">{`Impreso por software transporte`}</p>
          <p className="clear-space">{`Servicio básico de pasajeros`}</p>
        </div>
        {(stamp?.cufe || cufe) && (
          <div>
            <p className="clear-space">{stamp.cufe || cufe}</p>
          </div>
        )}
        {public_url && (
          <>
            <div className="qr-container">
              <QRCode value={public_url} size={130} />
              <a href={public_url} target="_blank" rel="noreferrer">
                Ver factura
              </a>
            </div>
          </>
        )}
      </div>
    );
  }
);
